export * from './odds-table-img';
export * from './betslip-basic-img';
export * from './betslip-float-img';